import { getDataSource } from "api/ds";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { ReportTable } from "./reportTable";
import { FindTextField } from "./FindTextField";
import { MemoTextField } from "./MemoTextField";
import { Box, Button, Card, CardContent, Checkbox, Divider, FormControlLabel, FormGroup, IconButton, styled, Switch, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import { colors } from "styles/colors";
import { get, getFile, postImage, post, delFts } from "api/apiBridges/httpBridge";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import { StyledTextInput, TextInput, TextInputDesign } from "./EIComponents/LittleComponents";
import _, { findIndex } from "lodash";
import Scrollbars from "rc-scrollbars";
import { pastelColors } from "./pastelColors";
import {StyledTab } from "utils/formatters";
import { TabPanel } from "./tabPanel";
import { useLocalNotifications } from "./Events";
import AddImage from '../images/others/AddImage.png';
import classicBC from '../images/others/classicBC.png';
import { BasicModal } from "./Modal";
import { SocketContext } from "./socketLib/ConnectorSocket";
import useOn from "./socketLib/UseOn";
import { getDocument } from "pdfjs-dist";
import { GlobalWorkerOptions } from "pdfjs-dist";
import { version } from "pdfjs-dist";
import Loading from "./Load";
import ClassicSearch from "./classicSearch";
import AddIcon from '../images/others/AddIcon.png';
import { MarketClientSelector } from "store/slices/marketClient";
import { ShowModal } from 'components/Modal';
import InfoIcon from '@mui/icons-material/Info';
import { hoverStyle } from "styles/main";
// GlobalWorkerOptions.workerSrc = "/pdf.worker.mjs";
//При таком подходе, если сервак cdn откиснет, то и библа вместе с ним
GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;

const textServices = `Комментарии к ТЗ`
const textServicesAdmin = `Комментарий к ТЗ не указан`


export const ServiceTab = styled(Tab)(({ theme }) => ({
    alignItems: "center",
    textTransform: "none",
    color: "#ffffff",
    transition: "all 0.2s ease-in-out",
    fontSize: "15px",
    
    // Способ 1: Уменьшение высоты через minHeight
    minHeight: '30px', // вместо стандартных 48px
    height: "30px",
    
    // Способ 2: Уменьшение отступов внутри компонента
    padding: '12px 12px', // вместо стандартных 12px 16px
    
    // Способ 3: Уменьшение высоты строки
    lineHeight: 1.2,

    "&.Mui-selected": {
        color: "#078376",
        fontWeight: 'bold',
    },
}));

// компонент для ввода тех задания
export function TechSpecif({ text, inServices, changeText, close, cancel, editable, customPrint, comment = "", fbs = false, hide = false, barcode=undefined, version=undefined, versionsCount, title, vendorCode, nmID, deal_id = undefined, cli_id = undefined, deltz=undefined, canHide = false, inMarket = undefined}) {
    // хранения текста через ref, чтобы не было кучи рендеров
    const textRef = useRef(text || '');
    const commentRef = useRef(comment);
    const ds = useMemo(() => getDataSource('addTech'), []);
    const packegeDS = editable? getDataSource("packageSelect"): getDataSource("packageSelectNoEdit")
    const consumesDS = editable? getDataSource("consumeSelect"): getDataSource("consumeSelectNoEdit")
    const otherServiceDS = editable? getDataSource("otherServiceDS"): getDataSource("otherServiceDSNoEdit")
    const [services, setServices] = useState([])
    const [selPrint, setSelPrint] = useState(customPrint || "")
    const [prints, setPrints] = useState([])
    const [selServices, setSelServices] = useState([])
    const [isOpen, setIsOpen] = useState(false);
    const [pendingServices, setPendingServices] = useState([]);
    const [data, setData] = useState({
        packff: [],
        packcli: [],
        consumabels: [],
        addit_consumabels: [],
        other: []
    })

    // console.log('TZ VERS', Object.keys(versionsCount).length)
    const [avaiblePackage, setAvaiblePackage] = useState([]);
    const [avaibleConsumes, setAvaibleConsumes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tab, setTab] = useState(0);

    const [selVersion, setSelVersion] = useState(undefined);
    const [commentVal, setCommentVal] = useState(comment || "");
    const [FBS, setFBS] = useState(fbs || false);
    const [hideTZ, setHideTZ] = useState(hide || false);

    const [canDel, setCanDel] = useState(false);
    const [delLoading, setDelLoading] = useState(true);

    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
        }
    );

    //Настройки Фильтра услуг
    const [checkedServ, setCheckedServ] = useState(false);
    const [filterServ, setFilterServ] = useState(null);
    const [filterFieldsServ, setFilterFieldsServ] = useState(
        {
            title: {name: "Название", active: true},
        }
    );
    const { market } = useSelector(MarketClientSelector);
    const [selMarket, setSelMarket] = useState(inMarket || market);

    const { showNotification } = useLocalNotifications();

    const checkCanDel = async () => {
        setDelLoading(true)
        let useInDeals = await get('Deal/checkTZ', {
                tz: version, 
                nmID: nmID,
                barcode: barcode,
                market:selMarket
            }
        )
        console.log("useInDeals", useInDeals)
        setCanDel(!useInDeals.message)
        setDelLoading(false)
    }

    
    useEffect(() => {
        if (version) {
            setSelVersion(version)
        }
        checkCanDel()
    }, [version])


    // @ts-ignore
    const handleChange = (event, newTab) => {
        //console.log("newTab", newTab)
        setTab(newTab);
    };

    const handleInputChange = (text) => {
        textRef.current = text;
    };

    const checkTabs = (chackData) => {
        let idxes = [0]
        let sidx1 = chackData.findIndex((fel) => fel.name === "Упаковка товара (фф)") 
        if (sidx1 > -1) {idxes.push(chackData[sidx1].name)}
        let sidx2 = chackData.findIndex((fel) => fel.name === "Упаковка товара (клиент)") 
        if (sidx2 > -1) {idxes.push(chackData[sidx2].name)}
        let sidx3 = chackData.findIndex((fel) => fel.name === "Комплектация товара")
        if (sidx3 > -1) {idxes.push(chackData[sidx3].name)}
        let sidx4 = chackData.findIndex((fel) => fel.name === "Дополнительные расходники")
        if (sidx4 > -1) {idxes.push(chackData[sidx4].name)}
        if (chackData?.filter((fel) => 
            fel.name !== "Комплектация товара" && 
            fel.name !== "Упаковка товара (фф)" &&
            fel.name !== "Упаковка товара (клиент)" &&
            fel.name !== "Дополнительные расходники"
        ).length > 0) {idxes.push('other')}
        //
        if (tab === 0 && idxes.length > 0) {
            setTab(idxes[0])
        }
        if (idxes.length > 0 && !idxes.includes(tab)) {
            setTab(idxes[0])
        }
        if (chackData.length === 0 && tab !== 0) {
            setTab(0)
        }
    }

    const changeServices = (name) => {        
        setSelServices(prev => {
            // Создаем копию актуального на данный момент состояния
            let tmp = [...prev];
            let idx = tmp.findIndex((el) => el.name === name);
            
            if (idx > -1) {
                // Если услуга уже есть — удаляем
                tmp.splice(idx, 1);
            } else {
                // Если нет — добавляем
                tmp.push({ name, data: {count: 1} });
            }

            checkTabs(tmp)
            
            return tmp; // Возвращаем обновленный массив
        });
    }

    const showErrorNotification = (type) => {
        let message = ""

        switch (type) {
            case "packff_empty":
                message = "Не указаны упаковки товара (фф)"
                break
            case "packff_count":
                message = "Количество в упаковке товара (фф) должно быть больше 0"
                break
            case "packcli_empty":
                message = "Не указаны упаковки товара (клиент)"
                break
            case "packcli_count":
                message = "Количество в упаковке товара (клиент) должно быть больше 0"
                break
            case "consum_empty":
                message = "Не указаны расходники для комплектации"
                break
            case "consum_count":
                message = "Количество расходников для комплектации должно быть больше 0"
                break
            case "addit_consum_empty":
                message = "Не указаны дополнительные расходники"
                break
            case "addit_consum_count":
                message = "Количество дополнительных расходников должно быть больше 0"
                break
            case "service_empty":
                message = "Количество для 'Другие услуги' должно быть больше 0"
                break
            default:
                message = "Ошибка при заполнении ТЗ"
        }

        showNotification({
            id: 'fieldsErr',
            type: 'error',
            message
        })
    }

    

    const acceptText = async () => {
        // Работаем только с копиями. Нельзя менять selServices во время валидации,
        // иначе сравнение с исходным inServices будет показывать ложные изменения.
        const tmp = JSON.parse(JSON.stringify(data))
        const servicesToSave = JSON.parse(JSON.stringify(selServices))
        const originalServices = JSON.parse(JSON.stringify(inServices || []))
        let errorType = null

        const setError = (type) => {
            if (!errorType) errorType = type
        }

        // --- Блок валидации ---
        const idxP1 = servicesToSave.findIndex((el) => el.name === "Упаковка товара (фф)")
        if (idxP1 > -1) {
            if (tmp.packff.length < 1) setError("packff_empty")
            tmp.packff.forEach((el) => {
                if (el.count < 1) setError("packff_count")
            })
            if (!errorType) {
                servicesToSave[idxP1].data = { packff: tmp.packff }
            }
        }

        const idxP2 = servicesToSave.findIndex((el) => el.name === "Упаковка товара (клиент)")
        if (idxP2 > -1) {
            if (tmp.packcli.length < 1) setError("packcli_empty")
            tmp.packcli.forEach((el) => {
                if (el.count < 1) setError("packcli_count")
            })
            if (!errorType) {
                const packcli = tmp.packcli.map((el) => ({
                    ...el,
                    ...(el.photo ? { photo: el.photopath } : {})
                }))
                servicesToSave[idxP2].data = { packcli }
            }
        }

        const idxCons = servicesToSave.findIndex((el) => el.name === "Комплектация товара")
        if (idxCons > -1) {
            if (tmp.consumabels.length < 1) setError("consum_empty")
            tmp.consumabels.forEach((el) => {
                if (el.count < 1) setError("consum_count")
            })
            if (!errorType) {
                const consumes = tmp.consumabels.map((el) => ({
                    ...el,
                    ...(el.photo ? { photo: el.photopath } : {})
                }))
                servicesToSave[idxCons].data = { consumes }
            }
        }

        const idxAdditCons = servicesToSave.findIndex((el) => el.name === "Дополнительные расходники")
        if (idxAdditCons > -1) {
            if (tmp.addit_consumabels.length < 1) setError("addit_consum_empty")
            tmp.addit_consumabels.forEach((el) => {
                if (el.count < 1) setError("addit_consum_count")
            })
            if (!errorType) {
                const additCons = tmp.addit_consumabels.map((el) => ({
                    ...el,
                    ...(el.photo ? { photo: el.photopath } : {})
                }))
                servicesToSave[idxAdditCons].data = { addit_cons: additCons }
            }
        }

        servicesToSave
            .filter((fel) =>
                fel.name !== "Комплектация товара" &&
                fel.name !== "Упаковка товара (фф)" &&
                fel.name !== "Упаковка товара (клиент)" &&
                fel.name !== "Дополнительные расходники"
            )
            .forEach((el) => {
                if ((el.data?.count ?? 0) <= 0) setError("service_empty")
            })
        // --- Конец блока валидации ---

        if (!errorType) {
            try {
                const useInDeals = await get('Deal/checkTZ', {
                    tz: selVersion,
                    nmID,
                    barcode,
                    market: selMarket,
                    ignore: deal_id
                })

                // Сравниваем именно исходное состояние с состоянием пользователя.
                // Ниже ничего не мутирует selServices/inServices.
                const servicesChanged = !_.isEqual(originalServices, servicesToSave)
                const textChanged = textRef.current !== text
                const printChanged = selPrint !== customPrint

                console.log("TZ changes", {
                    textChanged,
                    servicesChanged,
                    printChanged,
                    originalServices,
                    currentServices: servicesToSave
                })

                if (
                    useInDeals.message &&
                    (textChanged || servicesChanged || printChanged)
                ) {
                    ShowModal(
                        'Создание версии',
                        <div>Вы уверены, что хотите создать альтернативную версию?</div>,
                        async () => {
                            const versionNew = `alt_${Object.keys(versionsCount).length + 1}`
                            await changeText(
                                textRef.current,
                                servicesToSave,
                                selPrint,
                                versionNew,
                                commentVal,
                                FBS
                            )
                            close()
                        }
                    )
                } else {
                    await changeText(
                        textRef.current,
                        servicesToSave,
                        selPrint,
                        selVersion,
                        commentVal,
                        FBS,
                        hideTZ
                    )
                    close()
                }
            } catch (err) {
                console.error("Ошибка при проверке ТЗ:", err)
            }
        } else {
            showErrorNotification(errorType)
        }
    }

const { user_id, company_id } = useSelector(loginSelector);

useEffect(() => {
    const fetchData = async () => {
        try {
            setLoading(true)
            // Убрали отсюда логику проверки TZ и ShowModal, оставляем только загрузку справочников
            const responseData = await get('Handbook/getOnName', {company_id, name: "services"});
            if (responseData.message?.[0].data) {
                let $data = JSON.parse(responseData.message[0].data)
                if ($data.values) setServices($data.values)
            }

            const responseDataHB = await get('Handbook/get', {company_id});
            let tmpPackage = []
            if (responseDataHB.message){
                responseDataHB.message.map((el) => {
                    let elData = JSON.parse(el.data)
                    if (elData.rowPlace?.val === "static.product.package") {
                        tmpPackage = [...tmpPackage, ...elData.values]
                    }
                })
            }
            let tmpPack = []
            tmpPackage.map((el) => {tmpPack.push({id:el.name, name:el.name, val:el.val, count: 1, size:el.size})})
            setAvaiblePackage(tmpPack)
                
            let consres = await get("consumables/getOnCli", {cid:cli_id || user_id})
            let tmp = []
            await Promise.all(consres.map(async (el) => {
                let photo = undefined
                let photopath = undefined
                if (el.photo) {
                    let img = await getFile("png", {path:el.photo})
                    photopath = el.photo
                    photo = img
                }
                tmp.push({id:el.id, name:el.title, val:el.id, type: el.consum, color:el.color, size:el.size, count: 1, photo, photopath, rck: el.rck})
            }))
            console.log("setAvaibleConsumes", tmp)
            setAvaibleConsumes(tmp)

            if (barcode) {
                let tmpPrints = await get("client_custom_bc/get", {bar:barcode})
                if (tmpPrints) setPrints(tmpPrints)
            }
        }
        catch (e) { console.log(e) }
        finally { setLoading(false) }
    }
    fetchData();
}, []);

    useEffect(() => {
        if (inServices) {
            console.log("inServices", inServices)
            const checkPhoto = async ($data) => {
                await Promise.all($data.packff.map(async (el) => {
                    if (el.photo) {
                        let img = await getFile("png", {path:el.photopath})
                        el.photo = img
                    }
                }))
                await Promise.all($data.packcli.map(async (el) => {
                    if (el.photo) {
                        let img = await getFile("png", {path:el.photopath})
                        el.photo = img
                    }
                }))
                await Promise.all($data.consumabels.map(async (el) => {
                    if (el.photo) {
                        let img = await getFile("png", {path:el.photopath})
                        el.photo = img
                    }
                }))
                await Promise.all($data.addit_consumabels.map(async (el) => {
                    if (el.photo) {
                        let img = await getFile("png", {path:el.photopath})
                        el.photo = img
                    }
                }))

                setData($data)
                setSelServices(JSON.parse(JSON.stringify(inServices)))
                checkTabs(inServices)
            }

            const sourceServices = JSON.parse(JSON.stringify(inServices))
            let tmp = {packff:[], packcli: [], consumabels:[], addit_consumabels:[], other: []}
            let idxp1 = sourceServices.findIndex((el) => el.name === "Упаковка товара (фф)")
            if (idxp1 > -1) {tmp.packff = sourceServices[idxp1].data.packff}
            let idxp2 = sourceServices.findIndex((el) => el.name === "Упаковка товара (клиент)")
            if (idxp2 > -1) {tmp.packcli = sourceServices[idxp2].data.packcli}
            let idxCons1 = sourceServices.findIndex((el) => el.name === "Комплектация товара")
            if (idxCons1 > -1) {tmp.consumabels = sourceServices[idxCons1].data.consumes}
            let idxCons2 = sourceServices.findIndex((el) => el.name === "Дополнительные расходники")
            if (idxCons2 > -1) {tmp.addit_consumabels = sourceServices[idxCons2].data.addit_cons}
            checkPhoto(tmp)

        }
    }, [inServices])


    useEffect(() => {
        setSelPrint(customPrint || "")
    }, [customPrint])

    //Только для комплектации
    const editNumValue = (e) => {
        let tmp = JSON.parse(JSON.stringify(data))
        if (tmp.consumabels) {
            let idx = tmp.consumabels.findIndex((it) => it.id === e.row.id)    
            if (idx > -1) {tmp.consumabels[idx].count = e.count}
            else {
                let acidx = avaibleConsumes.findIndex((fel) => fel.id === e.row.id)
                if (acidx > -1) tmp.consumabels.push({...avaibleConsumes[acidx], count:e.count})
            }
        }
        else {
            let acidx = avaibleConsumes.findIndex((fel) => fel.id === e.row.id)
            tmp.consumabels = acidx > -1 ? [{...avaibleConsumes[acidx], count:e.count}] : []
        }
        
        setData(tmp)
    }

    const editNumValueAddit = (e) => {
        let tmp = JSON.parse(JSON.stringify(data))
        console.log("TEEEST", tmp)
        console.log("TEEEST1", e)
        if (tmp.addit_consumabels) {
            let idx = tmp.addit_consumabels.findIndex((it) => it.id === e.row.id)    
            console.log("TEEEST idx", idx)
            if (idx > -1) {tmp.addit_consumabels[idx].count = e.count}
            else {
                let acidx = avaibleConsumes.findIndex((fel) => fel.id === e.row.id)
                if (acidx > -1) tmp.addit_consumabels.push({...avaibleConsumes[acidx], count:e.count})
            }
        }
        else {
            let acidx = avaibleConsumes.findIndex((fel) => fel.id === e.row.id)
            tmp.addit_consumabels = acidx > -1 ? [{...avaibleConsumes[acidx], count:e.count}] : []
        }
        
        setData(tmp)
    }

    const editNumValueOther = (e) => {
        let tmp = JSON.parse(JSON.stringify(selServices))
        let idx = tmp.findIndex((it) => it.name === e.row.id)
        if (idx > -1) {
            tmp[idx].data = {
                ...tmp[idx].data,
                count: e.count
            }
        }
        console.log("tmp", tmp)
        setSelServices(tmp)
    }

     const editPackageValueFF = (selected) => {
        let tmpP = avaiblePackage.filter((el) => selected.includes(el.id))
        let tmp = JSON.parse(JSON.stringify(data))
        let res = []
        tmpP.map((el) => {
            let idx = tmp.packff.findIndex((it) => it.id === el.id)
            if (idx > -1) {res.push({...tmp.packff[idx]})}
            else (res.push({...el}))

        })
        _.set(tmp, "packff", res)
        setData(tmp)
    }

    const editPackageNumValueFF = (e) => {
        let tmp = JSON.parse(JSON.stringify(data))
        if (tmp.packff) {
            let idx = tmp.packff.findIndex((it) => it.id === e.row.id)    
            if (idx > -1) {tmp.packff[idx].count = e.count}
            else {
                let acidx = avaiblePackage.findIndex((fel) => fel.id === e.row.id)
                if (acidx > -1) tmp.packff.push({...avaiblePackage[acidx], count:e.count})
            }
        }
        else {
            let acidx = avaiblePackage.findIndex((fel) => fel.id === e.row.id)
            tmp.packff = acidx > -1 ? [{...avaiblePackage[acidx], count:e.count}] : []
        }
        
        setData(tmp)
    }

    const editPackageValueCli = (selected) => {
        let tmpP = avaibleConsumes.filter((el) => selected.includes(el.id) && el.type === "pack")
        let tmp = JSON.parse(JSON.stringify(data))
        let res = []
        tmpP.map((el) => {
            let idx = tmp.packcli.findIndex((it) => it.id === el.id)
            if (idx > -1) {res.push({...tmp.packcli[idx]})}
            else (res.push({...el}))

        })
        _.set(tmp, "packcli", res)
        setData(tmp)
    }

    const editPackageNumValueCli = (e) => {
        let tmp = JSON.parse(JSON.stringify(data))
        if (tmp.packcli) {
            let idx = tmp.packcli.findIndex((it) => it.id === e.row.id)    
            if (idx > -1) {tmp.packcli[idx].count = e.count}
            else {
                let acidx = avaibleConsumes.findIndex((fel) => fel.id === e.row.id)
                if (acidx > -1) tmp.packcli.push({...avaibleConsumes[acidx], count:e.count})
            }
        }
        else {
            let acidx = avaibleConsumes.findIndex((fel) => fel.id === e.row.id)
            tmp.packcli = acidx > -1 ? [{...avaibleConsumes[acidx], count:e.count}] : []
        }
        
        setData(tmp)
    }

    const editConsumesValue = (selected) => {
        let tmpP = avaibleConsumes.filter((el) => selected.includes(el.id) && el.type === "other")
        let tmp = JSON.parse(JSON.stringify(data))
        let res = []
        tmpP.map((el) => {
            let idx = tmp.consumabels.findIndex((it) => it.id === el.id)
            if (idx > -1) {res.push({...tmp.consumabels[idx]})}
            else (res.push(el))
    
        })
        _.set(tmp, "consumabels", res)
        setData(tmp)
    }

    const editAdditConsumesValue = (selected) => {
        let tmpP = avaibleConsumes.filter((el) => selected.includes(el.id) && el.type === "additional")
        let tmp = JSON.parse(JSON.stringify(data))
        let res = []
        tmpP.map((el) => {
            let idx = tmp.addit_consumabels.findIndex((it) => it.id === el.id)
            if (idx > -1) {res.push({...tmp.addit_consumabels[idx]})}
            else (res.push(el))
    
        })
        _.set(tmp, "addit_consumabels", res)
        setData(tmp)
    }

    const getServices = () => {
        let tmp = JSON.parse(JSON.stringify(services)) 
        tmp = tmp.filter(el => !selServices?.some(fel => fel.name === el.name))
        if (checkedServ) {
            tmp = tmp
            .filter((el) => {
            const tf = filterServ.toLowerCase(); 
            return (
                filterFieldsServ.title.active &&
                    el.name &&
                    String(el.name).toLowerCase().includes(tf)
            )})
        }
        if (tmp.length === 0) {
            return (<div style={{ padding: '10px', color: '#999', fontSize: '14px' }}>Пусто</div>)
        }
        else {
            return (
                <>
                {
                    tmp.map((el) => (
                        <label key={el.id || el.name} style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '8px 5px', 
                            cursor: 'pointer',
                            borderBottom: '1px solid #f0f0f0'
                        }}>
                            <input
                                type="checkbox"
                                style={{ marginRight: '10px', width: '16px', height: '16px', accentColor: '#208f84', flexShrink:0}}
                                checked={pendingServices.includes(el.name)}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setPendingServices([...pendingServices, el.name]);
                                    } else {
                                        setPendingServices(pendingServices.filter(name => name !== el.name));
                                    }
                                }}
                            />
                            <span style={{ fontSize: '14px' }}>{el.name}</span>
                        </label>
                    ))
                }
                </>
            )
        }
    }

    // console.log('services', services)
    // console.log('selServices', selServices)
    // console.log('avaiblePackage', avaiblePackage)
    // console.log('avaibleConsumes', avaibleConsumes)
    console.log('DATA', data)

    if (loading) {
        return <Loading></Loading>
    }

    return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', width: "100%"}}>

        <div style={{ height: '100%', display: 'flex', flexDirection: 'row', justifyContent: "space-between", marginBottom: "10px", alignItems: "flex-end"}}>
            {editable? <div style={{width: '30%'}}><TextInputDesign title={"Подсказка: "} val={commentVal} onChange={(v) => {setCommentVal(v)}}/></div>: <div></div>}
            <div style={{ 
                width: '65%',
                display: 'flex', 
                flexDirection: 'column', 
                lineHeight: 1.2,
                alignItems: 'flex-end',
                marginBottom: "5px", //Так как ввод занимает по факту больше места, за счет спрятанной части
                }}>
                <Typography variant="body2" sx={{ fontSize: '12pt'}}>
                    {title}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '12pt'}}>
                    Артикул: {vendorCode}, баркод: {barcode}
                </Typography>
            </div>
        </div>
        
        <div style={{width: "100%", display: 'flex', flexDirection: "row", marginBottom: "10px", justifyContent: "space-between"}}>
            <div style={{width: "28%", marginRight: "15px"}}>

                <div style={{ 
                    padding: '5px',
                    paddingLeft: "10px",
                    backgroundColor: '#f8f9fa', 
                    borderRadius: '10px',
                    border: '1px solid #e9ecef',
                    opacity: editable ? 1 : 0.7,
                    width:'100%',
                    height: "300px",
                    display: 'flex',
                    flexDirection: "column",
                    alignItems: "center"
                }}>

                    <div style={{
                        width: "100%", 
                        display: "flex", 
                        flexDirection: "row", 
                        alignItems: "center", 
                        justifyContent: 'space-between', 
                        marginBottom: "5px",
                        marginLeft: "5px"
                    }}>
                        <Typography variant="h6" style={{ color: '#7f8c8d'}}>
                            Выбранные услуги    
                        </Typography>
                        <Tooltip title={"Добавить услугу"}>
                            <IconButton onClick={() => editable && setIsOpen(!isOpen)}>
                                <img alt="" src={AddIcon} width={25} height={25}></img>
                            </IconButton>
                        </Tooltip>
                    </div>

                    
                    <div style={{ 
                        opacity: editable ? 1 : 0.6,
                        pointerEvents: editable ? 'auto' : 'none',
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-end"
                    }}>
                        <div style={{ display: 'flex', gap: '5px', flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end" }}>
                            <div style={{ position: 'relative', minWidth: '240px' }}>
                                {isOpen && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        zIndex: 1000,
                                        backgroundColor: 'white',
                                        border: '1px solid #ccc',
                                        borderRadius: '6px',
                                        marginTop: '4px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                        padding: '10px'
                                    }}>
                                        <Box >
                                            <ClassicSearch 
                                                setChecked={setCheckedServ} 
                                                setFilter={setFilterServ} 
                                                checked={checkedServ}
                                                customWidth={"220px"}
                                            />
                                        </Box>
                                        <Scrollbars style={{ height: "180px" }} autoHide>
                                            {getServices()}
                                        </Scrollbars>

                                        {/* Кнопка "Готово" внутри списка */}
                                        <button
                                            onClick={() => {
                                                pendingServices.forEach(name => changeServices(name));
                                                setPendingServices([]);
                                                setIsOpen(false);
                                            }}
                                            style={{
                                                marginTop: '10px',
                                                width: '100%',
                                                padding: '8px',
                                                backgroundColor: '#208f84',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Готово
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    
                    {selServices && selServices.length > 0?
                        <Scrollbars
                            style={{height: "230px"}} 
                            autoHide
                        >
                            <div style={{ display: 'flex', flexDirection: "row", gap: '10px', flexWrap: "wrap" }}>
                                {selServices.map((el) => (
                                    <div 
                                        key={el.id || el.name} 
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            gap: '10px',
                                            padding: '10px 15px',
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                            border: '1px solid #e0e0e0',
                                            transition: 'all 0.2s ease',
                                            width: "276px",
                                            position: 'relative'
                                        }}
                                    >
                                        <div style={{ 
                                            width: '12px', 
                                            height: '12px', 
                                            borderRadius: '50%', 
                                            backgroundColor: '#208f84' 
                                        }} />
                                        <div style={{width: '180px'}}>
                                            <Typography style={{ 
                                                fontWeight: '600', 
                                                fontSize: '12px', 
                                                color: '#2c3e50',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }}>
                                                {el.name}
                                            </Typography>
                                        </div>
                                        {editable && (
                                            <button
                                                onClick={() => changeServices(el.name)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: '#208f84',
                                                    cursor: 'pointer',
                                                    fontSize: '18px',
                                                    padding: '0 5px',
                                                    marginLeft: '5px'
                                                }}
                                                title="Удалить услугу"
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </Scrollbars>
                        :
                        <Typography variant="h6" style={{ color: '#7f8c8d', marginBottom: '10px' }}>
                            Нет выбранных услуг
                        </Typography>
                    }
                    </div>
                
                <div style={{marginTop: "10px"}}>
                    <MemoTextField             
                        text={text} 
                        handleInputChange={handleInputChange}
                        placeholder={editable? textServices : textServicesAdmin}
                        maxLength={500} 
                        editable={editable} 
                        rows={7}
                    />
                </div>
                
            </div>
            
            <div style={{width: "70%", display: "flex", flexDirection: 'column', alignItems: "flex-end"}}>
                {/* Блоки упаковки и расходников - всегда отображаются */}
                <Box sx={{ width: '100%', height: "100%", marginBottom: "5px"}}>
                
                    <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" 
                        sx={{
                            "& .MuiTabs-indicator": {
                                display: "none"
                            },
                             "& .MuiTabs-scrollButtons": {
                                color: '#ffffff',
                                '&.Mui-disabled': {
                                    opacity: 0.8
                                },
                                '&:hover': hoverStyle,
                            },
                            marginBottom: "5px",
                            height: "30px",
                            minHeight: "30px",
                            backgroundColor: "#bfddd9",
                            borderRadius: "10px"
                        }}
                        variant="scrollable"
                        scrollButtons={true}
                    >
                        {editable && <ServiceTab label='ШК' value={0}/>}
                        {selServices?.findIndex((fel) => fel.name === "Упаковка товара (клиент)") > -1 &&
                            <ServiceTab label='Упаковка товара (клиент)' value={'Упаковка товара (клиент)'}/>}
                        {selServices?.findIndex((fel) => fel.name === "Упаковка товара (фф)") > -1 &&
                            <ServiceTab label='Упаковка товара (фф)' value={'Упаковка товара (фф)'}/>}
                        {selServices?.findIndex((fel) => fel.name === "Комплектация товара") > -1 &&
                            <ServiceTab label='Комплектация товара' value={'Комплектация товара'}/>}
                        {selServices?.findIndex((fel) => fel.name === "Дополнительные расходники") > -1 &&
                            <ServiceTab label='Дополнительные расходники' value={'Дополнительные расходники'}/>}
                        {selServices?.filter((fel) => 
                            fel.name !== "Комплектация товара" && 
                            fel.name !== "Упаковка товара (фф)" &&
                            fel.name !== "Упаковка товара (клиент)" &&
                            fel.name !== "Дополнительные расходники"
                        ).length > 0 &&
                            <ServiceTab label='Другие услуги' value={'other'}/>}
                        
                    </Tabs>
                    <Box style={{marginTop: "20px", marginBottom: "20px"}}>
                        <ClassicSearch 
                            setChecked={setChecked} 
                            setFilter={setFilter} 
                            checked={checked}
                            fields={filterFields}
                            setFields={setFilterFields}
                        />
                    </Box>
                    {editable && 
                        <TabPanel value={0} select={tab}>
                            <Card sx={{ borderRadius: 3, boxShadow: 1, marginRight: "10px", marginBottom: "10px", width: "100%", height: "390px"}}>
                                <CardContent>
                                    <div style={{display: 'flex', flexDirection: "row", flexWrap: "wrap"}}>
                                        <CustomBC 
                                            photo={'classic'} 
                                            barcode={barcode}
                                            set={(path) => {setSelPrint(path)}}
                                            add={undefined}
                                            del={undefined}
                                            selected={selPrint === 'classic'}
                                        />
                                        {
                                            prints.map((P) => {
                                                return (
                                                    <CustomBC 
                                                        photo={P.photo} 
                                                        barcode={barcode}
                                                        set={(path) => {setSelPrint(path)}}
                                                        add={undefined}
                                                        del={(path) => {
                                                            let tmp = JSON.parse(JSON.stringify(prints))
                                                            setPrints(tmp.filter((fel) => fel.photo !== path))
                                                        }}
                                                        selected={selPrint === P.photo}
                                                    />
                                                )
                                            })
                                        }
                                        <CustomBC 
                                            photo={'create'} 
                                            barcode={barcode}
                                            set={(path) => {setSelPrint(path)}}
                                            add={
                                                (path) => {
                                                    let tmp = JSON.parse(JSON.stringify(prints))
                                                    tmp.push({barcode, photo:path})
                                                    setPrints(tmp)
                                                }
                                            }
                                            del={undefined}
                                        />
                                    </div>
                                </CardContent>
                            </Card>
                        </TabPanel>
                    }
                    <TabPanel value={"Упаковка товара (клиент)"} select={tab}>
                        <Card sx={{ borderRadius: 3, boxShadow: 1, marginRight: "10px", marginBottom: "10px", width: "100%", height: "390px"}}>
                            <CardContent>
                                <div style={{marginLeft:"10px", display: 'flex', flexDirection: "row", height:"390px"}}>
                                    <div style={{display: 'flex', flexDirection: "column", width: "100%"}}>
                                        <Scrollbars
                                            style={{height: "95%"}}
                                            autoHide
                                        >
                                            <ReportTable 
                                                ds={packegeDS} 
                                                data={
                                                    editable? 
                                                        !checked? 
                                                            [].concat(avaibleConsumes
                                                            .filter((el) => el.type === "pack"))
                                                            .map((cel) => {
                                                                let celidx = data.packcli.findIndex((fel) => fel.id===cel.id)
                                                                if (celidx > -1) {
                                                                    return {...cel, count: data.packcli[celidx].count}
                                                                }
                                                                return {...cel}
                                                            }).sort((a,b) => a.name.localeCompare(b.name))
                                                        :
                                                            [].concat(avaibleConsumes
                                                            .filter((el) => el.type === "pack"))
                                                            .map((cel) => {
                                                                let celidx = data.packcli.findIndex((fel) => fel.id===cel.id)
                                                                if (celidx > -1) {
                                                                    return {...cel, count: data.packcli[celidx].count}
                                                                }
                                                                return {...cel}
                                                            })
                                                            .filter((el) => {
                                                            const tf = filter.toLowerCase(); 
                                                            return (
                                                                filterFields.title.active &&
                                                                    el.name &&
                                                                    String(el.name).toLowerCase().includes(tf)
                                                            )}).sort((a,b) => a.name.localeCompare(b.name))

                                                    : 
                                                        !checked? 
                                                            [...data.packcli].sort((a,b) => a.name.localeCompare(b.name))
                                                        :
                                                            data.packcli
                                                            .filter((el) => {
                                                            const tf = filter.toLowerCase(); 
                                                            return (
                                                                filterFields.title.active &&
                                                                    el.name &&
                                                                    String(el.name).toLowerCase().includes(tf)
                                                            )}).sort((a,b) => a.name.localeCompare(b.name))

                                                } 
                                                onSelect={editable ? (selected) => editPackageValueCli(selected) : undefined}
                                                onFormatterChange={editable ? (e) => editPackageNumValueCli(e) : undefined}
                                                inputSelected={data.packcli.map((el) => el.id)}
                                                editable={editable}
                                            />
                                        </Scrollbars>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </TabPanel>
                    <TabPanel value={"Упаковка товара (фф)"} select={tab}>
                        <Card sx={{ borderRadius: 3, boxShadow: 1, marginRight: "10px", marginBottom: "10px", width: "100%", height: "390px"}}>
                            <CardContent>
                                <div style={{marginLeft:"10px", display: 'flex', flexDirection: "row", height:"390px"}}>
                                    <div style={{display: 'flex', flexDirection: "column", width: "100%"}}>
                                        <Scrollbars
                                            style={{height: "95%"}} 
                                            autoHide
                                        >
                                            <ReportTable 
                                                ds={packegeDS} 
                                                data={
                                                    editable? 
                                                        !checked?
                                                            [].concat(avaiblePackage)
                                                            .map((cel) => {
                                                                let celidx = data.packff.findIndex((fel) => fel.id===cel.id)
                                                                if (celidx > -1) {
                                                                    return {...cel, count: data.packff[celidx].count}
                                                                }
                                                                return {...cel}
                                                            }).sort((a,b) => a.name.localeCompare(b.name))
                                                        :
                                                            [].concat(avaiblePackage)
                                                            .map((cel) => {
                                                                let celidx = data.packff.findIndex((fel) => fel.id===cel.id)
                                                                if (celidx > -1) {
                                                                    return {...cel, count: data.packff[celidx].count}
                                                                }
                                                                return {...cel}
                                                            })
                                                            .filter((el) => {
                                                            const tf = filter.toLowerCase(); 
                                                            return (
                                                                filterFields.title.active &&
                                                                    el.name &&
                                                                    String(el.name).toLowerCase().includes(tf)
                                                            )}).sort((a,b) => a.name.localeCompare(b.name))
                                                    : 
                                                        !checked?
                                                            [...data.packff].sort((a,b) => a.name.localeCompare(b.name))
                                                        :
                                                            data.packff
                                                            .filter((el) => {
                                                            const tf = filter.toLowerCase(); 
                                                            return (
                                                                filterFields.title.active &&
                                                                    el.name &&
                                                                    String(el.name).toLowerCase().includes(tf)
                                                            )}).sort((a,b) => a.name.localeCompare(b.name))

                                                } 
                                                onSelect={editable ? (selected) => editPackageValueFF(selected) : undefined}
                                                onFormatterChange={editable ? (e) => editPackageNumValueFF(e) : undefined}
                                                inputSelected={data.packff.map((el) => el.id)}
                                                editable={editable}
                                            />
                                        </Scrollbars>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </TabPanel>
                    <TabPanel value={"Комплектация товара"} select={tab}>
                        <Card sx={{ borderRadius: 3, boxShadow: 1, marginRight: "10px",marginBottom: "10px", width: "100%", height: "390px"}}>
                            <CardContent>
                                <div style={{display: 'flex', flexDirection: "row", height:"390px"}}>
                                    <div style={{display: 'flex', flexDirection: "column", width:"100%", marginRight: "5px"}}>
                                        <Scrollbars
                                            style={{height: "95%"}} 
                                            autoHide
                                        >
                                            <ReportTable 
                                                ds={consumesDS} 
                                                data={
                                                    editable? 
                                                        !checked?
                                                            avaibleConsumes
                                                            .filter((el) => el.type === "other")
                                                            .map((cel) => {
                                                                let celidx = data.consumabels.findIndex((fel) => fel.id===cel.id)
                                                                if (celidx > -1) {
                                                                    return {...cel, count: data.consumabels[celidx].count}
                                                                }
                                                                return {...cel}
                                                            }).sort((a,b) => a.name.localeCompare(b.name))
                                                        :
                                                            avaibleConsumes
                                                            .filter((el) => el.type === "other")
                                                            .map((cel) => {
                                                                let celidx = data.consumabels.findIndex((fel) => fel.id===cel.id)
                                                                if (celidx > -1) {
                                                                    return {...cel, count: data.consumabels[celidx].count}
                                                                }
                                                                return {...cel}
                                                            })
                                                            .filter((el) => {
                                                            const tf = filter.toLowerCase(); 
                                                            return (
                                                                filterFields.title.active &&
                                                                    el.name &&
                                                                    String(el.name).toLowerCase().includes(tf)
                                                            )}).sort((a,b) => a.name.localeCompare(b.name))
                                                    : 
                                                        !checked?
                                                            [...data.consumabels].sort((a,b) => a.name.localeCompare(b.name))
                                                        :
                                                            data.consumabels
                                                            .filter((el) => {
                                                            const tf = filter.toLowerCase(); 
                                                            return (
                                                                filterFields.title.active &&
                                                                    el.name &&
                                                                    String(el.name).toLowerCase().includes(tf)
                                                            )}).sort((a,b) => a.name.localeCompare(b.name))
                                                } 
                                                onSelect={editable ? (selected) => editConsumesValue(selected) : undefined}
                                                onFormatterChange={editable ? (e) => editNumValue(e) : undefined}
                                                inputSelected={data.consumabels.map((el) => el.id)}
                                                editable={editable}
                                            />
                                        </Scrollbars>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </TabPanel>
                    <TabPanel value={"Дополнительные расходники"} select={tab}>
                        <Card sx={{ borderRadius: 3, boxShadow: 1, marginRight: "10px",marginBottom: "10px", width: "100%", height: "390px"}}>
                            <CardContent>
                                <div style={{display: 'flex', flexDirection: "row", height:"390px"}}>
                                    <div style={{display: 'flex', flexDirection: "column", width:"100%", marginRight: "5px"}}>
                                        <Scrollbars
                                            style={{height: "95%"}} 
                                            autoHide
                                        >
                                            <ReportTable 
                                                ds={consumesDS} 
                                                data={
                                                    editable? 
                                                        !checked?
                                                            avaibleConsumes
                                                            .filter((el) => el.type === "additional")
                                                            .map((cel) => {
                                                                let celidx = data.addit_consumabels.findIndex((fel) => fel.id===cel.id)
                                                                if (celidx > -1) {
                                                                    return {...cel, count: data.addit_consumabels[celidx].count}
                                                                }
                                                                return {...cel}
                                                            })
                                                        :
                                                            avaibleConsumes
                                                            .filter((el) => el.type === "additional")
                                                            .map((cel) => {
                                                                let celidx = data.addit_consumabels.findIndex((fel) => fel.id===cel.id)
                                                                if (celidx > -1) {
                                                                    return {...cel, count: data.addit_consumabels[celidx].count}
                                                                }
                                                                return {...cel}
                                                            })
                                                            .filter((el) => {
                                                            const tf = filter.toLowerCase(); 
                                                            return (
                                                                filterFields.title.active &&
                                                                    el.name &&
                                                                    String(el.name).toLowerCase().includes(tf)
                                                            )})
                                                    : 
                                                        !checked?
                                                            data.addit_consumabels
                                                        :
                                                            data.addit_consumabels
                                                            .filter((el) => {
                                                            const tf = filter.toLowerCase(); 
                                                            return (
                                                                filterFields.title.active &&
                                                                    el.name &&
                                                                    String(el.name).toLowerCase().includes(tf)
                                                            )})
                                                } 
                                                onSelect={editable ? (selected) => editAdditConsumesValue(selected) : undefined}
                                                onFormatterChange={editable ? (e) => editNumValueAddit(e) : undefined}
                                                inputSelected={data.addit_consumabels.map((el) => el.id)}
                                                editable={editable}
                                            />
                                        </Scrollbars>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </TabPanel>
                    <TabPanel value={"other"} select={tab}>
                        <Card sx={{ borderRadius: 3, boxShadow: 1, marginRight: "10px", marginBottom: "10px", width: "100%", height: "390px"}}>
                            <CardContent>
                                <div style={{marginLeft:"10px", display: 'flex', flexDirection: "row", height:"390px"}}>
                                    <div style={{display: 'flex', flexDirection: "column", width: "100%"}}>
                                        <Scrollbars
                                            style={{height: "95%"}} 
                                            autoHide
                                        >
                                            <ReportTable 
                                                ds={otherServiceDS} 
                                                data={
                                                    !checked?
                                                        selServices.filter((fel) => 
                                                            fel.name !== "Комплектация товара" && 
                                                            fel.name !== "Упаковка товара (фф)" &&
                                                            fel.name !== "Упаковка товара (клиент)" &&
                                                            fel.name !== "Дополнительные расходники"
                                                        ).map((el) => ({...el, id: el.name}))
                                                    :
                                                        selServices.filter((fel) => 
                                                            fel.name !== "Комплектация товара" && 
                                                            fel.name !== "Упаковка товара (фф)" &&
                                                            fel.name !== "Упаковка товара (клиент)" &&
                                                            fel.name !== "Дополнительные расходники"
                                                        ).map((el) => ({...el, id: el.name}))
                                                        .filter((el) => {
                                                        const tf = filter.toLowerCase(); 
                                                        return (
                                                            filterFields.title.active &&
                                                                el.name &&
                                                                String(el.name).toLowerCase().includes(tf)
                                                        )})
                                                }
                                                onFormatterChange={editable ? (e) => editNumValueOther(e) : undefined}
                                                editable={editable}
                                            />
                                        </Scrollbars>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </TabPanel>
                </Box>
            </div>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: "flex-end", width:'1150px'}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%"}}>
                {editable? 
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <Button 
                            onClick={cancel} 
                            variant="text" 
                            sx={{ 
                                height: "35px", 
                                width: "150px", 
                                textTransform: 'none', 
                                fontWeight: 'bold', 
                                marginBottom: '10px',
                                marginTop: '10px',
                                fontSize: "20px",
                                borderRadius: "10px"
                            }}
                        >
                            {"Отмена"}
                        </Button>
                        {canHide &&
                            <Button 
                                onClick={deltz} 
                                variant="text" 
                                disabled={!canDel || !deltz || version === 'main'}
                                sx={{ 
                                    height: "35px", 
                                    width: "150px", 
                                    textTransform: 'none', 
                                    fontWeight: 'bold', 
                                    marginBottom: '10px',
                                    marginTop: '10px',
                                    marginLeft: "20px",
                                    fontSize: "18px",
                                    borderRadius: "10px",
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    color: 'gray'
                                }}
                            >
                                {"Удалить ТЗ"}
                            </Button>
                        }
                        {canHide &&
                            <FormGroup sx={{marginLeft: "30px"}}>
                                <FormControlLabel 
                                    disabled={version === 'main'}
                                    control={<Switch checked={hideTZ} onChange={(e) => {setHideTZ(e.target.checked)}}/>} label="Скрывать" 
                                />
                            </FormGroup>
                        }
                        {canHide &&
                            <Tooltip 
                                title={
                                    <span>
                                        Удалить ТЗ – полное удаление ТЗ, доступно только если оно не используется в открытых сделках<br /><br />
                                        Скрыть ТЗ – ТЗ останется для существующих сделок, но с ним нельзя будет создать новую сделку<br /><br />
                                        Во избежание проблем ТЗ-1 нельзя скрыть или удалить
                                    </span>
                                } 
                                arrow
                                placement="top"
                            >
                                <InfoIcon 
                                    sx={{ 
                                        ml: 2, 
                                        color: 'gray', 
                                        cursor: 'help',
                                        fontSize: 20 
                                    }} 
                                />
                            </Tooltip>
                        }
                    </div>
                : <div></div>
                }
                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                    {editable? 
                        <FormGroup sx={{marginRight: "20px"}}>
                            <FormControlLabel 
                                control={<Switch checked={FBS} onChange={(e) => {setFBS(e.target.checked)}}/>} label="FBS" 
                            />
                        </FormGroup>
                    : <div></div>
                    }
                    <Button 
                        onClick={acceptText} 
                        variant="contained" 
                        sx={{ 
                            height: "35px", 
                            width: "150px", 
                            textTransform: 'none', 
                            backgroundColor: colors.elements, 
                            fontWeight: 'bold', 
                            marginBottom: '10px',
                            marginTop: '10px',
                            fontSize: "20px",
                            borderRadius: "10px"
                        }}
                    >
                        {editable? "Сохранить": "Закрыть"}
                    </Button>
                </div>
            </div>
        </div>
        
        
    </div>
);
}

export function CustomBC({photo, barcode, add, set, del, selected=false}){

    const [image, setImage] = useState("")
    const [canDel, setCanDel] = useState(false)

    const { showNotification } = useLocalNotifications();
    const { socket } = useContext(SocketContext);

    useEffect(() => {
        if (photo) {
            const checkPhoto = async () => {
                if (photo !== 'classic' && photo !== "create") {
                    let tmp = await getFile("png", {path:photo})
                    if (typeof tmp === "string") {
                        setImage(tmp)
                    }
                    let isUsed = await get("techTask/checkUsePhoto", {photo})
                    if (isUsed) {
                        setCanDel(!isUsed.used)
                    }
                }
                else {
                    setImage(photo)
                }
            }

            checkPhoto()
        }
    }, [photo])

    const handleDelete = async () => {
        await delFts('/delete-file', {path:[photo], taskType: "delImage"}, socket.id)
        await post("client_custom_bc/del", {photo})
        del(photo)
        showNotification({
            id: 'delCustomBCImage',
            type: 'success',
            message: 'ШК удален'
        });
    }

    const ImageClose = ({ img }) => {
        const [hovered, setHovered] = useState(false);

        const handleCheckboxClick = (event) => {
            event.stopPropagation();

            if (!selected && set) {
                set(photo);
            }
        };

        
        return (
            <Card
                sx={{
                    boxShadow: 1,
                    margin: "5px",
                    width: 70,
                    height: 105,
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "visible",
                }}
            >
                {/* Фиксированная hover-зона */}
                <div
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                        overflow: "visible",
                    }}
                >
                    {/* Checkbox */}
                    {set && !add && (
                        <div
                            onClick={handleCheckboxClick}
                            style={{
                                position: "absolute",
                                top: "3px",
                                left: "70%",
                                zIndex: 3,
                                cursor: "pointer",
                            }}
                        >
                            <Checkbox
                                checked={selected}
                                sx={{
                                    padding: "2px",
                                    pointerEvents: "auto",

                                    "& .MuiSvgIcon-root": {
                                        fontSize: 16,
                                        color: "#078376",
                                    },

                                    "&.Mui-checked": {
                                        color: "#078376",
                                    },
                                }}
                                size="small"
                            />
                        </div>
                    )}

                    {/* Изображение */}
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "white",
                            borderRadius: "5px",
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: selected
                                ? "3px solid #078376"
                                : "none",
                        }}
                    >
                        <img
                            alt=""
                            src={img}
                            style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                width: "auto",
                                height: "auto",
                                objectFit: "contain",
                                display: "block",
                                pointerEvents: "none",
                            }}
                        />
                    </div>

                    {/* Кнопка удаления */}
                    {del !== undefined && canDel && 
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: "30px",

                            background: "rgba(0, 0, 0, 0.6)",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            borderRadius: "0 0 5px 5px",

                            zIndex: 10,

                            // Начальное состояние
                            transform: hovered
                                ? "translateY(0)"
                                : "translateY(100%)",

                            opacity: hovered ? 1 : 0,

                            transition:
                                "transform 500ms ease, opacity 500ms ease",

                            // В скрытом состоянии кнопка
                            // не мешает hover
                            pointerEvents: hovered
                                ? "auto"
                                : "none",
                        }}
                    >
                        <button
                            onClick={handleDelete}
                            style={{
                                color: "#bd2d2d",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: "bold",
                                padding: "4px 8px",
                            }}
                        >
                            Удалить
                        </button>
                    </div>
                    }
                </div>
            </Card>
        );
    };

    const ImageOpen = ({ img }) => {
        const [imageOrientation, setImageOrientation] = useState('vertical');
        const [containerSize, setContainerSize] = useState({ width: 350, height: 525 });

        useEffect(() => {
            if (!img) return;

            const image = new Image();
            image.src = img;
            image.onload = () => {
                // Определяем ориентацию
                if (image.width > image.height) {
                    setImageOrientation('horizontal');
                    // Для горизонтальных: ширина 350, высота пропорциональная
                    const aspectRatio = image.height / image.width;
                    setContainerSize({
                        width: 350,
                        height: Math.round(350 * aspectRatio)
                    });
                } else {
                    setImageOrientation('vertical');
                    // Для вертикальных: высота 525, ширина пропорциональная
                    const aspectRatio = image.width / image.height;
                    setContainerSize({
                        width: Math.round(525 * aspectRatio),
                        height: 525
                    });
                }
            };
        }, [img]);

        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'white',
                width: '100%',
                height: '100%',
                maxWidth: containerSize.width,
                maxHeight: containerSize.height,
                margin: '0 auto'
            }}>
                <img 
                    alt="" 
                    src={img} 
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        width: imageOrientation === 'horizontal' ? '100%' : 'auto',
                        height: imageOrientation === 'horizontal' ? 'auto' : '100%',
                        objectFit: 'contain',
                        display: 'block'
                    }} 
                />
            </div>
        );
    };


    useOn('uploadCBCImage', async (data) => {
        //console.log("uploadDealImage", data);
        if (data?.path) {
            if (add) {
                add(data.path)
            }
            if (set) {
                set(data.path)
            }
        }
    });

    const handleFileUpload = async (event) => {
        let selectedFiles = Array.from(event.target.files);
        
        if (!selectedFiles || selectedFiles.length === 0) {
            return;
        }
        
        showNotification({
            id: 'uploadCustomBCImage',
            type: 'info',
            message: 'Загрузка'
        });
        
        // Обрабатываем все файлы
        const processedFiles = [];
        
        for (const file of selectedFiles) {
            try {
                // Проверяем тип файла
                if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
                    //console.log('Обнаружен PDF файл:', file.name);
                    
                    // Преобразуем одностраничный PDF в изображение
                    const imageFile = await convertSinglePagePdfToImage(file);
                    if (imageFile) {
                        processedFiles.push(imageFile);
                    } else {
                        console.warn(`PDF файл ${file.name} не был преобразован`);
                    }
                } 
                // Проверяем, является ли файл изображением
                else if (file.type === "image/png" || file.type === "image/jpeg") {
                    //console.log('Обнаружено изображение:', file.name);
                    processedFiles.push(file);
                } 
                // Неподдерживаемый формат
                else {
                    showNotification({
                        id: 'unsupportedFormat',
                        type: 'warning',
                        message: `Файл "${file.name}" имеет неподдерживаемый формат. Разрешены только изображения (png или jpeg) и PDF`
                    });
                    continue;
                }
            } catch (error) {
                console.error(`Ошибка обработки файла ${file.name}:`, error);
                showNotification({
                    id: 'fileProcessingError',
                    type: 'error',
                    message: `Ошибка обработки файла ${file.name}`
                });
            }
        }
        
        // Если есть обработанные файлы, отправляем их
        if (processedFiles.length > 0) {
            try {
                await postImage(processedFiles, socket.id, {
                    user_id: barcode,
                    role: 'custom_bc_print',
                    content_type: "uploadCBCImage",
                    barcode
                });
                
                // Показываем уведомление об успехе
                showNotification({
                    id: 'uploadSuccess',
                    type: 'success',
                    message: `Успешно загружено файлов: ${processedFiles.length}`
                });
                
            } catch (error) {
                console.error('Ошибка при отправке файлов:', error);
                showNotification({
                    id: 'uploadError',
                    type: 'error',
                    message: 'Ошибка при загрузке файлов'
                });
            }
        } else {
            showNotification({
                id: 'noValidFiles',
                type: 'warning',
                message: 'Нет подходящих файлов для загрузки'
            });
        }
        
        // Очищаем поле выбора файлов
        event.target.value = '';
        selectedFiles = [];
    };

    // Функция преобразования одностраничного PDF в PNG изображение
    const convertSinglePagePdfToImage = async (pdfFile) => {
        try {
            
            // Показываем уведомление о начале обработки PDF
            showNotification({
                id: 'processingPdf',
                type: 'info',
                message: `Обработка PDF: ${pdfFile.name}`
            });
            
            // Читаем файл как ArrayBuffer
            const arrayBuffer = await pdfFile.arrayBuffer();
            
            // Загружаем PDF документ
            const pdfDocument = await getDocument({ 
                data: arrayBuffer,
                // Опциональные параметры для лучшей производительности
                cMapUrl: 'https://unpkg.com/pdfjs-dist@2.16.105/cmaps/',
                cMapPacked: true,
            }).promise;
            
            // Проверяем количество страниц
            const numPages = pdfDocument.numPages;
            //console.log(`PDF содержит ${numPages} страниц`);
            
            if (numPages > 1) {
                showNotification({
                    id: 'multiPagePdfWarning',
                    type: 'warning',
                    message: `PDF "${pdfFile.name}" содержит ${numPages} страниц. Для печати штрихкодов используйте только одностраничные PDF`
                });
                return null;
            }
            
            if (numPages === 0) {
                showNotification({
                    id: 'emptyPdf',
                    type: 'warning',
                    message: `PDF "${pdfFile.name}" не содержит страниц`
                });
                return null;
            }
            
            // Получаем первую (и единственную) страницу
            const page = await pdfDocument.getPage(1);
            
            // Настраиваем параметры рендеринга
            const scale = 3.0; // Высокое разрешение для качественной печати
            const viewport = page.getViewport({ scale });
            
            // Создаем временный canvas для рендеринга
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            
            // Устанавливаем размеры canvas
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.style.width = `${viewport.width / scale}px`;
            canvas.style.height = `${viewport.height / scale}px`;
            
            // Настраиваем фон для прозрачности
            context.fillStyle = 'white';
            context.fillRect(0, 0, canvas.width, canvas.height);
            
            // Рендерим страницу PDF на canvas
            const renderContext = {
                canvasContext: context,
                viewport: viewport,
                // Дополнительные опции для лучшего качества
                enableWebGL: false,
                useWorker: false,
            };
            
            await page.render(renderContext).promise;
            
            // Конвертируем canvas в Blob (PNG)
            const blob = await new Promise((resolve) => {
                canvas.toBlob(resolve, 'image/png', 1.0);
            });
            
            if (!blob) {
                throw new Error('Не удалось создать изображение из PDF');
            }
            
            // Создаем новый файл с расширением PNG
            const fileName = pdfFile.name.replace(/\.pdf$/i, '.png');
            const imageFile = new File([blob], fileName, {
                type: 'image/png',
                lastModified: Date.now()
            });
            
            //console.log(`PDF успешно преобразован в PNG: ${fileName} (${Math.round(blob.size / 1024)}KB)`);
            
            // Очищаем ресурсы
            canvas.remove();
            pdfDocument.destroy();
            
            return imageFile;
            
        } catch (error) {
            console.error('Ошибка при преобразовании PDF в изображение:', error);
            
            showNotification({
                id: 'pdfConversionError',
                type: 'error',
                message: `Ошибка при обработке PDF "${pdfFile.name}"`
            });
            
            return null;
        }
    };

    if (image === "classic") {
        return (
            <BasicModal 
                childOpen={<ImageOpen img={classicBC}></ImageOpen>} 
                childClose={<ImageClose img={classicBC}></ImageClose>}>    
            </BasicModal>
        )
    }

    if (image === "create") {
        return (
            <>
                <input
                    type="file"
                    multiple
                    accept="application/png"
                    style={{ display: "none" }}
                    id={`create-new`}
                    onChange={(e) => handleFileUpload(e)}
                />
                <label htmlFor={`create-new`}>
                    <ImageClose img={AddImage}></ImageClose>
                </label>
            </>
        )
    }

    return (
        <BasicModal 
            childOpen={<ImageOpen img={image}></ImageOpen>} 
            childClose={<ImageClose img={image}></ImageClose>}>    
        </BasicModal>
    )

}

export function getTMPVersion() {
  const date = new Date();
  
  const year = date.getFullYear().toString().slice(-2); // последние 2 цифры года
  const month = String(date.getMonth() + 1).padStart(2, '0'); // месяц (01-12)
  const day = String(date.getDate()).padStart(2, '0'); // день (01-31)
  const hours = String(date.getHours()).padStart(2, '0'); // часы (00-23)
  const minutes = String(date.getMinutes()).padStart(2, '0'); // минуты (00-59)
  
  return `tmp_${year}-${month}-${day}-${hours}-${minutes}`;
}